import { action, makeObservable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import type { RepositoryShockProfiles } from "../../domain/repositories/repository-shock-profiles";
import { type UUID } from "../../utils/uuid";
import { FormCreateShockProfile } from "../molecules/form-create-shock-profile";
import { FormUpdateShockProfile } from "../molecules/form-update-shock-profile";
import { ListCommandButtons, type ListCommandButtonsProps } from "./list-command-buttons";
import { defaultPageSize } from "../../utils/constants";

export type ListCommandButtonsShockProfilesProps = Omit<
    ListCommandButtonsProps<RepositoryShockProfiles>,
    "list" | "createForm" | "listState"
> & {};

import { store } from "../../store";

@observer
export class ListCommandButtonsShockProfiles extends React.Component<ListCommandButtonsShockProfilesProps> {
    constructor(props: ListCommandButtonsShockProfilesProps) {
        super(props);
        makeObservable(this);
    }

    @action.bound private async deleteShockProfiles(ids: UUID[]): Promise<void> {
        await store.repositoryShockProfiles.delete(...ids);
        if (this.props.onDelete) {
            this.props.onDelete(ids);
        }
        store.repositoryShockProfiles.reloadQuery({
            pageSize: defaultPageSize,
        });
    }

    @action.bound private reloadShockProfiles(): void {
        store.repositoryShockProfiles.reloadQuery({
            pageSize: defaultPageSize,
        });
    }

    public render(): JSX.Element {
        return (
            <ListCommandButtons
                updateForm={FormUpdateShockProfile}
                createForm={(props) => <FormCreateShockProfile {...props} />}
                listState={store.serviceListStates.shockProfiles}
                {...this.props}
                onDelete={this.deleteShockProfiles}
                onCreate={this.reloadShockProfiles}
                createDialogTitle={store.i18n.t("listShockProfiles.createDialog.title")}
                createButtonText={store.i18n.t("listShockProfiles.createButton.name")}
                updateDialogTitle={store.i18n.t("listShockProfiles.updateDialog.title")}
            />
        );
    }
}
